import styled from 'styled-components';

export const SplitWrapper = styled.div`
  width: calc(50% - 10px);
`;
